import { useEffect, useState } from 'react';

export default function useResponsive() {
  const [isPortrait, setIsPortrait] = useState(false);
  const [isBig, setIsBig] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [isTablet, setIsTablet] = useState(false);
  
  const responsive = { isBig: isBig, isTablet: isTablet, isMobile: isMobile, isPortrait: isPortrait };

  useEffect(() => {
    const handleOrientationChange = () => {
      setIsPortrait(window.matchMedia('(orientation: portrait)').matches ? true : false);
    };

    window.addEventListener('resize', handleOrientationChange);
    window.addEventListener('orientationchange', handleOrientationChange);
    handleOrientationChange();

    return () => {
      window.removeEventListener('resize', handleOrientationChange);
      window.removeEventListener('orientationchange', handleOrientationChange);
    };
  }, []);

  useEffect(() => {
    const handleResize = () => {
        const width = window.innerWidth;

        const big = width >= 1024;
        const tablet = width >= 432 && width < 1024;
        const mobile = width < 432;
        setIsBig(big);
        setIsMobile(mobile);
        setIsTablet(tablet);
      };
  
      // Suscribirse al evento resize para actualizar el ancho de la pantalla cuando cambie
      window.addEventListener('resize', handleResize);
      handleResize();
      // Eliminar el event listener cuando el componente se desmonte
      return () => {
        window.removeEventListener('resize', handleResize);
      };
  }, []);

  return responsive;
}
